import React from "react"
import {
  WingsDetailText,
} from "../typography"
import "./WingsHeroSpacer.css"

const WingsHeroSpacer = ({
  className = "",
  label = null,
  children = null,
  categories = "",
}) => {
  const content = children ?? categories

  if (!label && !content) {
    return null
  }

  return (
    <div className={`wings-hero-spacer w-flex w-items-center w-justify-center ${className}`}>
      <div className="wings-hero-spacer-content w-container w-flex w-flex-row w-items-center w-justify-start w-py-1 w-gap-x-3 w-gap-y-2">
        <WingsDetailText>
          {label ? <>{label}:&nbsp;</> : null}
          {content}
        </WingsDetailText>
      </div>
    </div>
  )
}

export default WingsHeroSpacer
